import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { money } from "../../../../../../../../../../../utils/numeral/money";
import { formatDate } from "../../../../../../../../../../../utils/helpers/date-time/datetime-format";
import { TooltipText } from "../../../../../../../../../../common/TooltipText";
import { ResourceExplorerCostsDateDetails } from "../../../../../../../../../../../services/cloudchipr.api";

interface TotalCostColumnHeaderCellProps {
  totalCost?: number;
  dateDetails?: ResourceExplorerCostsDateDetails;
}
export const TotalCostColumnHeaderCell: FC<TotalCostColumnHeaderCellProps> = ({
  totalCost,
  dateDetails,
}) => {
  const toDate = formatDate(dateDetails?.to_date ?? "", { type: "date" });
  const fromDate = formatDate(dateDetails?.from_date ?? "", {
    type: "date",
  });
  const titleComponent = (
    <Box>
      Total Cost <br /> from{" "}
      <Typography fontWeight="medium" fontSize="inherit" component="span">
        {fromDate}
      </Typography>{" "}
      to{" "}
      <Typography fontWeight="medium" fontSize="inherit" component="span">
        {toDate}
      </Typography>
    </Box>
  );

  return (
    <Stack alignItems="end" flexGrow={1}>
      <TooltipText
        fontWeight="medium"
        tooltipPlacement="top"
        tooltipTitle={fromDate && toDate ? titleComponent : ""}
      >
        <div> Total Cost</div>
      </TooltipText>

      <Typography
        mt={0.5}
        fontSize={10}
        color="text.disabled"
        align="right"
        fontWeight={500}
      >
        {money(totalCost)}
      </Typography>
    </Stack>
  );
};
